import React, { useRef } from "react";
import { Modal, Button } from "antd";
import { PrinterOutlined, FilePdfOutlined } from "@ant-design/icons";
import oneBell from "../../../../assets/images/license/oneBell.png";

// ─────────────────────────────────────────────────────────────────────────────
// Utilities
// ─────────────────────────────────────────────────────────────────────────────
const fmtMoney = (v) =>
  Number(v || 0).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtDate = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d)) return "-";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

const SectionHeader = ({ children }) => (
  <div
    style={{
      background: "#1a3a5c",
      color: "#fff",
      fontWeight: 700,
      fontSize: 14,
      padding: "3px 8px",
      margin: "8px 0 4px",
      letterSpacing: 0.4,
    }}
  >
    {children}
  </div>
);

const LabelValue = ({ label, value, bold, color }) => (
  <div
    style={{
      display: "flex",
      fontSize: 12,
      padding: "1px 0",
      gap: 4,
      alignItems: "baseline",
    }}
  >
    <span style={{ color: "#555", whiteSpace: "nowrap", minWidth: 80 }}>
      {label}
    </span>
    <span
      style={{
        fontWeight: bold ? 700 : 400,
        color: color || "#222",
        wordBreak: "break-all",
      }}
    >
      {value ?? "-"}
    </span>
  </div>
);

const Row2 = ({ label, value }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      fontSize: 12,
      padding: "2px 0",
      borderBottom: "1px dashed #e0e8f0",
    }}
  >
    <span style={{ color: "#555" }}>{label}</span>
    <span style={{ fontWeight: 600, minWidth: 90, textAlign: "right" }}>
      {value}
    </span>
  </div>
);

const calculateSumary = (value) => {
  console.log("value", value);
  const def1 = value.judgeDef?.find((d) => d.judgeNumber === 1) || {};
  const compensation = parseFloat(value.judgementLack)
    ? parseFloat(value.judgementLack)
    : parseFloat(value.judgement);
  const compensationPercent = parseInt(value.interestRate)
    ? parseFloat(value.interestRate / 100) || 1
    : parseFloat(value.judgeInterestRate / 100) || 1;
  //ค่าขาดประโยชน์
  const costOfUselessness = parseFloat(value.lackOfBenefits)
    ? parseFloat(value.lackOfBenefits)
    : 0;
  const costOfUselessnessPerCent = parseInt(value.interestRateOfLack)
    ? parseFloat(value.interestRateOfLack / 100)
    : 1;
  const costOfUselessnessSum = costOfUselessness * costOfUselessnessPerCent;
  //ค่าขาดประโยชน์ รายเดือน
  const costOfUselessnessPerMonth = parseFloat(def1.costOfUselesenessPerMonth);
  const costOfUselessnessMonth = parseInt(def1.costOfUselesenessMonth) || 1;
  const costOfUselessnessPerMonthSum =
    costOfUselessnessPerMonth * costOfUselessnessMonth;
  console.log("costOfUselessnessSum", costOfUselessnessSum);

  const summaryValue =
    compensation +
    costOfUselessness +
    parseInt(value.attorneyFees) +
    parseInt(value.trackingFee) +
    parseInt(value.fee) +
    costOfUselessnessPerMonthSum +
    costOfUselessnessSum;
  console.log("--->", compensationPercent);

  console.log("summaryValue", summaryValue);
};

const getJudgeDef1 = (judgeData) => {
  return judgeData?.judgeDef?.find((d) => d.judgeNumber === 1) ?? {};
};

function ProductTranferBody({
  dataDB2,
  billPayment,
  judgeData,
  lawsuitData,
  dataDefault,
  status,
}) {
  const company = billPayment?.company?.[0] || {};
  const pay = billPayment?.pay || [];
  const customer = dataDB2?.CUSTOMER || {};
  const address = customer?.ADDRESS?.[0] || {};
  const guarantors = dataDB2?.GUARANTORS || [];
  const mortgage = dataDB2?.MORTGAGE || {};
  const loan = dataDB2?.LOAN || {};
  const loanNew = judgeData?.loanNew || {};
  const NCSHPRC = Number(loanNew?.NCSHPRC || pay[0]?.NCSHPRC || 0);
  const TOT_UPAY = Number(loanNew?.TOT_UPAY || pay[0]?.TOT_UPAY || 0);
  const T_NOPAY = Number(loanNew?.T_NOPAY || pay[0]?.T_NOPAY || 0);
  const fDate = new Date(loanNew?.FDATE || loan.FDATE);
  const dayOfMonth = isNaN(fDate) ? "05" : fDate.getDate();

  const newContno = loanNew?.NEW_CONTNO || pay[0]?.newContno || "-";
  const oldContno = loan.CONTNO || pay[0]?.CONTNO || "-";
  const def1 = getJudgeDef1(judgeData);
  console.log("dataDefault", dataDefault);

  return (
    <div
      style={{
        fontFamily: "'Sarabun', 'TH Sarabun New', sans-serif",
        background: "#fff",
        color: "#111",
        padding: "10mm 10mm 10mm",
        fontSize: 12,
        lineHeight: 1.6,
        width: 794,
        maxWidth: 794,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* ── HEADER ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 6,
        }}
      >
        <div style={{ maxWidth: "55%" }}>
          <div style={{ fontWeight: 800, fontSize: 12, color: "#1a3a5c" }}>
            {company.COMP_NM || "-"}
          </div>
          <div style={{ fontSize: 12, color: "#444" }}>{company.COMP_ADR1}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div
            style={{
              border: "2.5px solid #1a3a5c",
              padding: "4px 18px",
              display: "inline-block",
              fontSize: 14,
              fontWeight: 900,
              color: "#1a3a5c",
              letterSpacing: 2,
              marginBottom: 4,
            }}
          >
            ใบส่งสินค้า
          </div>
          <div style={{ fontSize: 12, color: "#555" }}>
            เลขที่ <strong>{newContno}</strong>{" "}
            <strong style={{ color: "#e74c3c" }}>
              {(dataDefault?.flagLoanNew === 2 || status === 2) &&
              dataDefault?.LAW_TYPE_ID === 6
                ? "(พิพากษา(ฟ้องส่วนต่าง))"
                : (dataDefault?.flagLoanNew === 2 || status === 2) &&
                    dataDefault?.LAW_TYPE_ID !== 6
                  ? "(พิพากษา)"
                  : (dataDefault?.flagLoanNew === 1 || status === 1) &&
                      dataDefault?.LAW_TYPE_ID === 6
                    ? "(ทำยอม(ฟ้องส่วนต่าง))"
                    : "(ทำยอม)"}
            </strong>
          </div>
          <div style={{ fontSize: 12, color: "#555" }}>
            วันที่ทำสัญญา <strong>{fmtDate(judgeData?.SDATE)}</strong>
          </div>
        </div>
      </div>

      <div style={{ borderTop: "2px solid #1a3a5c", marginBottom: 6 }} />

      {/* Contract ref row */}
      <div style={{ fontSize: 12, marginBottom: 4 }}>
        สถานที่ทำสัญญา: <strong>{company.COMP_ADR1}</strong>
      </div>

      {/* ── CUSTOMER ── */}
      <SectionHeader>รายละเอียดลูกค้า</SectionHeader>
      <div
        style={{
          paddingLeft: 8,
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0 16px",
        }}
      >
        <LabelValue
          label="ชื่อลูกค้า"
          value={`${customer.SNAM || ""}${customer.NAME1 || ""} ${customer.NAME2 || ""}`}
          bold
        />
        <LabelValue label="เลขบัตรประชาชน" value={customer.CUSCOD} />
        <LabelValue
          label="ที่อยู่"
          value={`${address.ADDR1 || ""} ต.${address.TUMB || ""} อ.${address.AUMPDES || ""} จ.${address.PROVDES || ""} ${address.ZIP || ""}`}
        />
        <LabelValue label="อาชีพ" value={customer.OFFIC} />
        <LabelValue label="โทรศัพท์" value={address.TELP} />
        <LabelValue label="ที่ทำงาน" value={customer.OCCUP} />
      </div>

      {/* ── GUARANTORS ── */}
      {guarantors.length > 0 && (
        <>
          <SectionHeader>รายละเอียดผู้ค้ำประกัน</SectionHeader>
          <div style={{ paddingLeft: 8 }}>
            {guarantors.map((g, i) => {
              const ga = g.ADDRESS?.[0] || {};
              return (
                <div
                  key={i}
                  style={{
                    marginBottom: 4,
                    paddingBottom: 4,
                    borderBottom:
                      i < guarantors.length - 1 ? "1px dashed #dce8ff" : "none",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: "0 16px",
                    }}
                  >
                    <LabelValue
                      label={`ชื่อผู้ค้า ${i + 1} (${g.RELATN || ""})`}
                      value={`${g.SNAM || ""}${g.NAME1 || ""} ${g.NAME2 || ""}`}
                      bold
                    />
                    <LabelValue label="เลขบัตรประชาชน" value={g.CUSCOD} />
                    {/* <LabelValue
                      label="ที่อยู่"
                      value={`${ga.ADDR1 || ""} ต.${ga.TUMB || ""} อ.${ga.AUMPDES || ""} จ.${ga.PROVDES || ""} ${ga.ZIP || ""}`}
                    /> */}
                    {/* <LabelValue label="อาชีพ" value={g.OFFIC} /> */}
                    <LabelValue label="โทรศัพท์" value={ga.TELP} />
                    {/* <LabelValue label="ที่ทำงาน" value={g.OCCUP} /> */}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* ── MORTGAGE ── */}
      <SectionHeader>รายละเอียดสินค้า</SectionHeader>
      <div
        style={{
          paddingLeft: 8,
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "0 16px",
        }}
      >
        <LabelValue
          label="ยี่ห้อ รุ่น"
          value={`${mortgage.TYPE || ""} ${mortgage.MODEL || ""}`}
          bold
        />
        <LabelValue label="แบบ" value={mortgage.BAAB} />
        <LabelValue label="สี" value={mortgage.COLOR} />
        <LabelValue
          label="ทะเบียน"
          value={`${mortgage.REGNO || "-"} ${mortgage.DORECV || ""}`}
          bold
        />
        <LabelValue label="ปีที่ผลิต" value={mortgage.MANUYR} />
        <LabelValue label="สถานะสินค้า" value="รถมือสอง" />
        <LabelValue label="เลขตัวถัง" value={mortgage.STRNO} />
        <LabelValue label="เลขเครื่อง" value={mortgage.ENGNO} />
      </div>

      {/* ── PAYMENT CONDITIONS + SALES INFO ── */}
      {loanNew?.NEW_CONTNO ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 0,
            marginTop: 6,
            border: "1px solid #ccd8ea",
          }}
        >
          {/* ── ซ้าย: เงื่อนไขการชำระเงิน ── */}
          <div style={{ borderRight: "1px solid #ccd8ea" }}>
            <SectionHeader>เงื่อนไขการชำระเงิน(ทำยอม)</SectionHeader>
            <div style={{ padding: "4px 8px", fontSize: 12 }}>
              {/* sub-header */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  fontWeight: 700,
                  borderBottom: "1px solid #ccd8ea",
                  paddingBottom: 2,
                  marginBottom: 3,
                }}
              >
                <span>รายการ</span>
                <span style={{ textAlign: "center" }}>วันถึงกำหนดชำระ</span>
                <span style={{ textAlign: "right" }}>จำนวนเงิน</span>
              </div>

              {/* งวดที่ 1 */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  padding: "2px 0",
                  borderBottom: "1px dashed #e0e8f0",
                }}
              >
                <span>งวดที่ 1 ถึง {T_NOPAY - 1}</span>
                <span style={{ textAlign: "center" }}>
                  {fmtDate(loanNew?.FDATE)}
                </span>
                <span style={{ textAlign: "right" }}>
                  {fmtMoney(loanNew?.TOT_UPAY * (T_NOPAY - 1))}
                </span>
              </div>

              {/* งวดที่ 2 ถึง N */}
              {/* <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  padding: "2px 0",
                  borderBottom: "1px dashed #e0e8f0",
                }}
              >
                <span>งวดที่ 2 ถึง {T_NOPAY - 1}</span>
                <span style={{ textAlign: "center", fontSize: 14 }}>
                  ทุกวันที่ {dayOfMonth} ของเดือนถัดไป
                </span>
                <span style={{ textAlign: "right" }}>
                  {fmtMoney(loanNew?.TOT_UPAY * (T_NOPAY - 2))}
                </span>
              </div> */}

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  padding: "2px 0",
                  borderBottom: "1px dashed #e0e8f0",
                }}
              >
                <span>งวดที่ {T_NOPAY}</span>
                <span style={{ textAlign: "center", fontSize: 14 }}>
                  {fmtDate(loanNew?.LDATE)}
                </span>
                <span style={{ textAlign: "right" }}>
                  {fmtMoney(
                    loanNew.LOAN_NEW_TONBALANCE -
                      loanNew?.TOT_UPAY * (T_NOPAY - 1),
                  )}
                </span>
              </div>

              {/* จ่ายทุก */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  padding: "3px 0",
                  borderBottom: "1px dashed #e0e8f0",
                  fontSize: 12,
                }}
              >
                <span>
                  จ่ายงวดทุก 1 เดือน ทุกวันที่ {dayOfMonth} ของเดือนถัดไป
                </span>
                {/* <span>
                  วันที่งวดสุดท้าย <strong>{fmtDate(loanNew?.LDATE)}</strong>
                </span> */}
              </div>

              <div
                style={{
                  marginTop: 6,
                  borderTop: "1px solid #ccd8ea",
                  paddingTop: 4,
                }}
              >
                <Row2
                  label="ข้อมูลการขาย    ยอดจัด"
                  value={fmtMoney(loanNew?.NCSHPRC)}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 14,
                    padding: "2px 0",
                    borderBottom: "1px dashed #e0e8f0",
                  }}
                >
                  <span>
                    รีไฟแนนซ์ <strong>{loanNew?.ISSUNO || oldContno}</strong>
                  </span>
                  <span style={{ display: "flex", gap: 6 }}>
                    <strong style={{ textDecoration: "underline" }}>หัก</strong>
                    <span>ยอดปิด</span>
                    <span style={{ fontWeight: 600 }}>
                      {fmtMoney(loanNew?.NCSHPRC)}
                    </span>
                  </span>
                </div>
                <Row2
                  label={
                    <span>
                      <strong style={{ textDecoration: "underline" }}>
                        หัก
                      </strong>{" "}
                      ค่าจัด
                    </span>
                  }
                  value="0.00"
                />
                <Row2
                  label={
                    <span>
                      <strong style={{ textDecoration: "underline" }}>
                        หัก
                      </strong>{" "}
                      ค่าต่อทะเบียนและค่าใช้จ่ายอื่น
                    </span>
                  }
                  value="0.00"
                />
                {/* <Row2
                  label={
                    <span
                      style={{ fontWeight: 700, textDecoration: "underline" }}
                    >
                      ยอดจ่ายเช็ค
                    </span>
                  }
                  value="0.00"
                /> */}
              </div>
            </div>
          </div>

          {/* ── ขวา: รายละเอียดการขาย ── */}
          <div>
            <SectionHeader>รายละเอียดการขาย</SectionHeader>
            <div style={{ padding: "4px 8px" }}>
              <Row2 label="(1) ราคาขายสด" value={`${fmtMoney(NCSHPRC)} บาท`} />
              <Row2 label="(2) ดอกผล" value="0.00 บาท" />
              <Row2
                label="(3) ขายเช่าซื้อ (1)+(2)"
                value={`${fmtMoney(NCSHPRC)} บาท`}
              />
              <Row2 label="(4) เงินดาวน์" value="0.00 บาท" />
              <Row2
                label="(5) เงินคงค้าง (3)-(4)"
                value={`${fmtMoney(NCSHPRC)} บาท`}
              />
              <Row2
                label={`(6) จ่ายชำระ ${T_NOPAY} งวด ๆ ละ`}
                value={`${fmtMoney(TOT_UPAY)} บาท`}
              />
              <Row2
                label={`(7) อัตราดอกเบี้ย (เมื่อผิดนัดชำระ)`}
                value={`${judgeData?.judgeInterestRate !== "0" ? judgeData?.judgeInterestRate : judgeData?.interestRate !== "0" ? judgeData?.interestRate : "-"}% /ปี`}
              />

              <div
                style={{
                  marginTop: 6,
                  borderTop: "1px solid #ccd8ea",
                  paddingTop: 4,
                }}
              >
                <Row2
                  label="ราคารวมสุทธิ:"
                  value={`${fmtMoney(judgeData.totalJugde)} บาท`}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <SectionHeader>รายละเอียดคำพิพากษา</SectionHeader>
          <div style={{ padding: "4px 8px" }}>
            <Row2
              label={`${billPayment.check8 !== "" ? `รีไฟแนนซ์ (${billPayment.check8})` : "รีไฟแนนซ์"}`}
              value={`${judgeData?.CONTNO}`}
            />
            {/* <Row2
              label={` ทุนทรัพย์ฟ้อง (+ค่าขาดประโยชน์)`}
              value={`${fmtMoney(lawsuitData?.litigationFunds || 0 + lawsuitData.lackOfBenefits || 0)} บาท`}
            /> */}
            <Row2
              label={`(1) ค่าชดใช้แทน.`}
              value={`${fmtMoney(judgeData?.judgement)} บาท`}
            />
            <Row2
              label={`(2) ต้นเงิน.`}
              value={`${fmtMoney(judgeData?.judgementLack)} บาท`}
            />
            <Row2
              label={`(3) วันเริ่มต้นคิดดอกเบี้ย             (อัตราดอกเบี้ย ${judgeData?.judgeInterestRate !== "0" ? judgeData?.judgeInterestRate : judgeData?.interestRate || "-"} %/ปี)`}
              value={`${fmtDate(def1.firstDate)}`}
            />
            <Row2
              label="(4) ค่าขาดประโยชน์"
              value={`${fmtMoney(judgeData?.lackOfBenefits)} บาท`}
            />
            <Row2
              label={`(5) วันเริ่มต้นคิดดอกเบี้ย             (อัตราดอกเบี้ย ${judgeData?.interestRateOfLack !== "0" ? judgeData?.interestRateOfLack : "-"} %/ปี)`}
              value={`${fmtDate(def1?.costFirstDate)}`}
            />
            <Row2
              label={`(6) ค่าขาดประโยชน์รายเดือน " ${def1?.costOfUselesenessMonth || "-"} " เดือน ๆ ละ ${fmtMoney(def1?.costOfUselesenessPerMonth)} บาท`}
              value={`${fmtMoney(def1?.costOfUselesenessPerMonth * (def1?.costOfUselesenessMonth || 1))} บาท`}
            />
            <Row2
              label="(7) ค่าฤชาศาล"
              value={`${fmtMoney(judgeData?.fee)} บาท`}
            />
            <Row2
              label="(8) ค่าติดตาม"
              value={`${fmtMoney(judgeData?.trackingFee)} บาท`}
            />
            <Row2
              label="(9) ค่าทนาย"
              value={`${fmtMoney(judgeData?.attorneyFees)} บาท`}
            />

            <div
              style={{
                marginTop: 6,
                borderTop: "1px solid #ccd8ea",
                paddingTop: 4,
              }}
            >
              <Row2
                label="ราคารวมสุทธิ:"
                value={`${fmtMoney(judgeData.totalJugde)} บาท`}
              />
            </div>
          </div>
        </div>
      )}

      {/* ── SIGNATURES ── */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4,1fr)",
          gap: 10,
          marginTop: 16,
        }}
      >
        {[
          { label: "ผู้ซื้อ(ผู้รับสินค้า)", signature: null },
          { label: `${lawsuitData?.FNAME}/(ผู้ขาย)`, signature: null },
          { label: `${lawsuitData?.FNAME}/(ผู้ตรวจสอบ)`, signature: null },
          {
            label: "(ผู้อนุมัติ)",
            signature: judgeData.checkJudge ? oneBell : null,
          },
        ].map(({ label, signature }) => (
          <div
            key={label}
            style={{ textAlign: "center", fontSize: 12, paddingTop: 4 }}
          >
            <div
              style={{
                height: 48,
                margin: "0 10px 4px",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                position: "relative",
              }}
            >
              {/* รูปลายเซ็น (ถ้ามี) */}
              {signature && (
                <img
                  src={signature}
                  alt="signature"
                  style={{
                    position: "absolute",
                    bottom: 4,
                    height: 40,
                    objectFit: "contain",
                    opacity: 0.85,
                  }}
                />
              )}
              {/* เส้นประ */}
              <div
                style={{
                  borderBottom: "1px dotted #666",
                  width: "100%",
                }}
              />
            </div>
            <div style={{ color: "#444" }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ProductTranfer({
  open,
  onClose,
  dataDB2,
  billPayment,
  judgeData,
  lawsuitData,
  dataDefault,
  status,
}) {
  console.log("dataDefault", dataDefault);
  const printRef = useRef();

  // ── Print ──────────────────────────────────────────────────────────────
  const handlePrint = () => {
    const content = printRef.current?.innerHTML || "";
    const win = window.open("", "_blank", "width=960,height=1200");
    win.document.write(`<!DOCTYPE html><html>
      <head>
      <meta charset="utf-8"/>
      <style>
        * { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:Sarabun,'TH Sarabun New',sans-serif; font-size:12px; background:#fff; }
        @page { size:A4; margin:0mm; }
        @media print { body { -webkit-print-color-adjust:exact; print-color-adjust:exact; } }
      </style>
    </head>
    <body>${content}</body>
  </html>`);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
      win.close();
    }, 600);
  };

  // ── Export PDF ─────────────────────────────────────────────────────────
  const handleExportPDF = async () => {
    const loadScript = (src) =>
      new Promise((res, rej) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          res();
          return;
        }
        const s = document.createElement("script");
        s.src = src;
        s.onload = res;
        s.onerror = rej;
        document.head.appendChild(s);
      });

    try {
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js",
      );
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js",
      );

      const el = printRef.current;

      const savedScrollY = window.scrollY; // อ่านก่อน
      el.style.width = "794px";

      const canvas = await window.html2canvas(el, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        windowWidth: 794,
        width: 794,
        x: 0,
        scrollX: 0,
        scrollY: -savedScrollY,
      });

      // ✅ reset หลัง capture
      el.style.width = "";
      el.style.maxWidth = "";

      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfW = pdf.internal.pageSize.getWidth(); // 210mm
      const pageH = pdf.internal.pageSize.getHeight(); // 297mm
      const pdfH = (canvas.height * pdfW) / canvas.width;
      const imgData = canvas.toDataURL("image/jpeg", 0.97);

      let y = 0;
      while (y < pdfH) {
        if (y > 0) pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, -y, pdfW, pdfH);
        y += pageH;
      }

      const newContno =
        judgeData?.loanNew?.NEW_CONTNO ||
        billPayment?.pay?.[0]?.newContno ||
        "delivery";
      pdf.save(`ใบส่งสินค้า_${newContno}.pdf`);
    } catch (err) {
      console.error("PDF export error:", err);
    }
  };

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@400;600;700;800&display=swap');`}</style>
      <Modal
        open={open}
        onCancel={onClose}
        width={840}
        title="📦 ใบส่งสินค้า (Delivery Note)"
        destroyOnHidden
        styles={{
          body: {
            maxHeight: "78vh",
            overflowY: "auto",
            padding: "8px 0",
            background: "#f0f4fa",
          },
        }}
        footer={[
          <Button key="close" onClick={onClose}>
            ปิด
          </Button>,
          <Button key="print" icon={<PrinterOutlined />} onClick={handlePrint}>
            พิมพ์
          </Button>,
          <Button
            key="pdf"
            type="primary"
            icon={<FilePdfOutlined />}
            onClick={handleExportPDF}
            style={{ background: "#c0392b", borderColor: "#c0392b" }}
          >
            ดาวน์โหลด PDF
          </Button>,
        ]}
      >
        <div ref={printRef} style={{ width: 794, overflow: "hidden" }}>
          <ProductTranferBody
            dataDB2={dataDB2}
            billPayment={billPayment}
            judgeData={judgeData}
            lawsuitData={lawsuitData}
            dataDefault={dataDefault}
            status={status}
          />
        </div>
      </Modal>
    </>
  );
}
